module.exports = __webpack_public_path__ + "7965db59794da81dd0ad5f118b0617ba.svg";